import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const updateKbArticleStatus = createAsyncThunk(
    'kbBulkActions/updateKbArticleStatus',
    async ({ articleIds, status, group_id }, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;
            const url = `${ROOT_URL}/kb/articles/status`;
            const response = await axios.patch(url, { articleIds, status, group_id }, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });
            return { articleIds, status, message: response.data.message };
        } catch (error) {
            console.error('Error updating status:', error);
            return rejectWithValue(
                error.response?.data?.message || 'Failed to update status'
            );
        }
    }
);

export const updateKbArticleVisibility = createAsyncThunk(
    'kbBulkActions/updateKbArticleVisibility',
    async ({ articleIds, visibility, group_id }, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;
            const url = `${ROOT_URL}/kb/articles/visibility`;
            const response = await axios.patch(url, { articleIds, visibility, group_id }, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });
            return { articleIds, visibility, message: response.data.message };
        } catch (error) {
            console.error('Error updating visibility:', error);
            return rejectWithValue(
                error.response?.data?.message || 'Failed to update visibility'
            );
        }
    }
);

export const updateKbArticleCategory = createAsyncThunk(
    'kbBulkActions/updateKbArticleCategory',
    async ({ articleIds, categoryIds, group_id }, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;
            const url = `${ROOT_URL}/kb/articles/categories`;
            const response = await axios.patch(url, { articleIds, categoryIds, group_id }, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });
            return { articleIds, categoryIds, message: response.data.message };
        } catch (error) {
            console.error('Error updating category:', error);
            return rejectWithValue(
                error.response?.data?.message || 'Failed to update category'
            );
        }
    }
);

const initialState = {
    bulkActionLoading: false,
    error: null,
    successMessage: null,
};

const kbBulkActionsSlice = createSlice({
    name: 'kbBulkActions',
    initialState,
    reducers: {
        clearBulkActionState: (state) => {
            state.bulkActionLoading = false;
            state.error = null;
            state.successMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateKbArticleStatus.pending, (state) => {
                state.bulkActionLoading = true;
                state.error = null;
            })
            .addCase(updateKbArticleStatus.fulfilled, (state, action) => {
                state.bulkActionLoading = false;
                state.successMessage = action.payload.message;
            })
            .addCase(updateKbArticleStatus.rejected, (state, action) => {
                state.bulkActionLoading = false;
                state.error = action.payload;
            })
            .addCase(updateKbArticleVisibility.pending, (state) => {
                state.bulkActionLoading = true;
                state.error = null;
            })
            .addCase(updateKbArticleVisibility.fulfilled, (state, action) => {
                state.bulkActionLoading = false;
                state.successMessage = action.payload.message;
            })
            .addCase(updateKbArticleVisibility.rejected, (state, action) => {
                state.bulkActionLoading = false;
                state.error = action.payload;
            })
            .addCase(updateKbArticleCategory.pending, (state) => {
                state.bulkActionLoading = true;
                state.error = null;
            })
            .addCase(updateKbArticleCategory.fulfilled, (state, action) => {
                state.bulkActionLoading = false;
                state.successMessage = action.payload.message;
            })
            .addCase(updateKbArticleCategory.rejected, (state, action) => {
                state.bulkActionLoading = false;
                state.error = action.payload;
            });
    }
});

export const { clearBulkActionState } = kbBulkActionsSlice.actions;
export default kbBulkActionsSlice.reducer;
